<template>
  <section>
    <div class="container">
      <header class="circleHeader">
        <h2>The Team</h2>
      </header>
      <div v-for="(teamMember, index) in team" :key="index" class="teamMember">
        <div class="img" :style="{ backgroundImage: `url(${photo(teamMember.photo)})` }"></div>
        <div>
          <header>
            <h3>
              <span v-html="teamMember.name"></span>
            </h3>
            <h4 v-html="teamMember.role"></h4>
          </header>
          <div v-html="teamMember.bio"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'the-team',
  props: ['team'],
  methods: {
    photo (photo) {
      if (photo && photo.sizes) {
        let image = photo.sizes.medium
        if (process.env.NODE_ENV === 'development') {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
        }
        return image
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors

  section
    padding-top: 132px
    padding-bottom: 100px
    .container
      h2
        font-size: 40px
    .circleHeader
      margin-bottom: 44px
      &:before
        background: $yellow
</style>

<style lang="sass">
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .teamMember
    +tablet
      display: flex
    margin-bottom: 64px
    a
      color: inherit
      font-weight: bold
      &:hover
        color: lighten($textColor, 25%)
    &:last-child
      margin-bottom: 0
    .img
      width: 240px
      height: 240px
      border: 8px solid $yellow
      border-radius: 50%
      background: #fff
      background-size: cover
      background-position: 50% 50%
      margin: 0 auto 10px 
      +tablet
        margin: 0 18px 0 0
    > div:last-child
      flex: 1
      h3
        font-size: 26px
        line-height: 32px
        font-weight: bold
        margin-bottom: 0
        margin-top: 15px
        +tablet
          font-size: 32px
          line-height: 46px
        a
          display: block
          +tablet
            display: inline
            .fa
              font-size: 37px
              vertical-align: -2px
              margin-left: 14px
          .fa
            font-size: 30px

      h4
        font-size: 20px
        line-height: 1
        font-weight: bold
        +tablet
          font-size: 26px
      p
        font-size: 16px
        line-height: 1.75
        +tablet
          font-size: 18px
          line-height: 30px
</style>



// WEBPACK FOOTER //
// TheTeam.vue?20cc34e8